import React, { forwardRef } from 'react';
import './CustomTogglebox.css';
import Togglebox from './Togglebox';

function CustomTogglebox({placeholder, onChange, checked = false, label = ""}, ref) {
  const container = (
    <div className={"customToggleboxContainer"}>
      <p>{placeholder}</p>
      <Togglebox ref={ref} onChange={onChange} checked={checked} />
    </div>
  );

  if (label) {
    return (
      <div className="textFieldWrapper">
        <label className="textFieldLabel">{label}</label>
        {container}
      </div>
    );
  }
  return container;
}

export default forwardRef(CustomTogglebox)